import React, { useEffect } from 'react';

// rows: array of [slot, spec1Name, spec2Name, ...]
// specs: array of spec display names corresponding to columns 1..n
// renderCell: function(name, slot, si) => React node for the cell
export default function BisTables({ rows, specs, renderCell }){
  // Ensure favicon is present (some SPA navigations can lose or override it)
  useEffect(() => {
    try {
      const href = '/favicon.ico';
      const existing = document.querySelector('link[rel="icon"]');
      if (existing) {
        if (existing.getAttribute('href') !== href) existing.setAttribute('href', href);
        return;
      }
      const link = document.createElement('link');
      link.rel = 'icon';
      link.href = href;
      document.head.appendChild(link);
    } catch(_) {}
  }, []);
  return (
    <>
      {/* Desktop: one table with Slot + one column per spec */}
      <div className="desktop-only">
        <div className="bis-table-wrap">
          <table className="bis-table" role="table">
            <thead>
              <tr>
                <th>Slot</th>
                {specs.map(s => <th key={s}>{s}</th>)}
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => {
                const slot = r[0];
                const rowClass = i % 2 === 0 ? 'even' : 'odd';
                return (
                  <tr key={i} className={rowClass}>
                    <td className="slot" data-label="Slot">{slot}</td>
                    {specs.map((spec, si) => {
                      const name = r[1 + si] || '';
                      const specClass = spec.toLowerCase().replace(/\s+/g,'-');
                      return (
                        <td key={spec} className={specClass} data-label={slot}>{ renderCell(name, slot, si) }</td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      {/* Mobile: render one small table per spec (stacked single-spec tables) */}
      <div className="mobile-only">
        {specs.map((spec, si) => (
          <div className="bis-table-wrap" key={spec}>
            <div className="bis-spec-title">{spec}</div>
            <table className="bis-table" role="table">
              <thead>
                <tr>
                  <th>Item</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((r, i) => {
                  const slot = r[0];
                  const name = r[1 + si] || '';
                  const rowClass = i % 2 === 0 ? 'even' : 'odd';
                  const specClass = spec.toLowerCase().replace(/\s+/g,'-');
                  return (
                    <tr key={i} className={rowClass}>
                      <td className={specClass} data-label={slot}>{ renderCell(name, slot, si) }</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ))}
      </div>
    </>
  );
}
